import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from './auth/AuthContext';
import { AdminLayout, CheckinLayout, GuestLayout, PublicLayout } from './components/layouts';
import { Loader } from './components/ui';
import {
  GuestLoginPage,
  HomePage,
  NotFoundPage,
  PrivacyPage,
  StaffLoginPage,
  VerificationPage,
} from './pages/PublicPages';

const GalleryPage = lazy(() =>
  import('./pages/GalleryPage').then((module) => ({ default: module.GalleryPage })),
);
const AdminDashboardPage = lazy(() =>
  import('./pages/AdminPages').then((module) => ({ default: module.AdminDashboardPage })),
);
const AdminWeddingPage = lazy(() =>
  import('./pages/AdminPages').then((module) => ({ default: module.AdminWeddingPage })),
);
const AdminCeremoniesPage = lazy(() =>
  import('./pages/AdminPages').then((module) => ({ default: module.AdminCeremoniesPage })),
);
const AdminGuestsPage = lazy(() =>
  import('./pages/AdminPages').then((module) => ({ default: module.AdminGuestsPage })),
);
const AdminAgentsPage = lazy(() =>
  import('./pages/AdminMorePages').then((module) => ({ default: module.AdminAgentsPage })),
);
const AdminTablesPage = lazy(() =>
  import('./pages/AdminMorePages').then((module) => ({ default: module.AdminTablesPage })),
);
const AdminAuditPage = lazy(() =>
  import('./pages/AdminMorePages').then((module) => ({ default: module.AdminAuditPage })),
);
const CheckinCeremoniesPage = lazy(() =>
  import('./pages/CheckinPages').then((module) => ({ default: module.CheckinCeremoniesPage })),
);
const CheckinSearchPage = lazy(() =>
  import('./pages/CheckinPages').then((module) => ({ default: module.CheckinSearchPage })),
);
const GuestPortalPage = lazy(() =>
  import('./pages/GuestPages').then((module) => ({ default: module.GuestPortalPage })),
);
const AttendancePage = lazy(() =>
  import('./pages/GuestPages').then((module) => ({ default: module.AttendancePage })),
);
const InvitationDetailPage = lazy(() =>
  import('./pages/GuestPages').then((module) => ({ default: module.InvitationDetailPage })),
);

export function App() {
  return (
    <Suspense fallback={<Loader label="Chargement de l’espace…" />}>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/galerie" element={<GalleryPage />} />
          <Route path="/connexion" element={<GuestLoginPage />} />
          <Route path="/verification" element={<VerificationPage />} />
          <Route path="/confidentialite" element={<PrivacyPage />} />
          <Route path="/admin/connexion" element={<StaffLoginPage role="admin" />} />
          <Route path="/accueil/connexion" element={<StaffLoginPage role="agent" />} />
        </Route>
        <Route
          element={
            <RequireAuth principalType="guest">
              <GuestLayout />
            </RequireAuth>
          }
        >
          <Route path="/ma-presence" element={<AttendancePage />} />
          <Route path="/mon-espace" element={<GuestPortalPage />} />
          <Route path="/mes-invitations/:id" element={<InvitationDetailPage />} />
        </Route>
        <Route
          element={
            <RequireAuth principalType="staff" role="admin">
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/mariage" element={<AdminWeddingPage />} />
          <Route path="/admin/ceremonies" element={<AdminCeremoniesPage />} />
          <Route path="/admin/invites" element={<AdminGuestsPage />} />
          <Route path="/admin/agents" element={<AdminAgentsPage />} />
          <Route path="/admin/tables" element={<AdminTablesPage />} />
          <Route path="/admin/audit" element={<AdminAuditPage />} />
        </Route>
        <Route
          element={
            <RequireAuth principalType="staff" role="agent">
              <CheckinLayout />
            </RequireAuth>
          }
        >
          <Route path="/accueil/ceremonies" element={<CheckinCeremoniesPage />} />
          <Route path="/accueil/recherche" element={<CheckinSearchPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
